import DescriptionDetails from "./DescriptionDetails";

export default DescriptionDetails